import { Table } from '@popsure/dirty-swan';

export default Table;
